module.exports = __webpack_public_path__ + "img/dolphin.69577f31.png";